import { memo } from 'react';

import ReviewerRoleIconSVG from '@/assets/reviewer-role-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IReviewerRoleIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={ReviewerRoleIconSVG} {...props} />
);

export const ReviewerRoleIcon = memo(IReviewerRoleIcon) as typeof IReviewerRoleIcon;
